import React, { useState } from "react";
import { db } from "../firebaseConfig"; // Ensure you have the correct Firestore configuration file path
import { collection, addDoc } from "firebase/firestore";

const ContactUsPage = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await addDoc(collection(db, "feedback"), formData);
      console.log("Form submitted:", formData);
      alert("Thank you for your feedback!");
      setFormData({ name: "", email: "", message: "" });
    } catch (error) {
      console.error("Error submitting feedback:", error);
      alert("Something went wrong. Please try again.");
    }
  };

  return (
    <div
      style={{
        fontFamily: "'Helvetica', Arial, sans-serif",
        padding: "40px 20px",
        backgroundColor: "#f5f5f5",
        minHeight: "100vh",
      }}
    >
      <section
        style={{
          maxWidth: "800px",
          margin: "0 auto",
          padding: "20px",
          backgroundColor: "#fff",
          borderRadius: "10px",
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        }}
      >
        <h1
          style={{
            fontSize: "3rem",
            textAlign: "center",
            marginBottom: "20px",
            color: "black",
          }}
        >
          Contact Us
        </h1>
        <p
          style={{
            textAlign: "center",
            fontSize: "1.2rem",
            color: "#333",
            marginBottom: "30px",
          }}
        >
          <strong>Call us:</strong>{" "}
          <a
            href="tel:+14698349406"
            style={{
              color: "#000",
              textDecoration: "none",
              fontWeight: "bold",
              fontSize: "1.1rem",
            }}
          >
            +1 (469) 834-9406
          </a>
          <br />
          <strong>Email us:</strong>{" "}
          <a
            href="mailto:jordan@gier.ai"
            style={{
              color: "#007bff",
              textDecoration: "none",
              fontWeight: "bold",
            }}
          >
            jordan@gier.ai
          </a>
        </p>
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: "15px" }}>
            <label
              htmlFor="name"
              style={{
                display: "block",
                fontSize: "1.2rem",
                marginBottom: "5px",
                color: "#333",
              }}
            >
              Name:
            </label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              style={{
                width: "95%",
                padding: "10px",
                fontSize: "1rem",
                borderRadius: "5px",
                border: "1px solid #ccc",
                color: "#333",
              }}
            />
          </div>
          <div style={{ marginBottom: "15px" }}>
            <label
              htmlFor="email"
              style={{
                display: "block",
                fontSize: "1.2rem",
                marginBottom: "5px",
                color: "#333",
              }}
            >
              Email:
            </label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              style={{
                width: "95%",
                padding: "10px",
                fontSize: "1rem",
                borderRadius: "5px",
                border: "1px solid #ccc",
                color: "#333",
              }}
            />
          </div>
          <div style={{ marginBottom: "15px" }}>
            <label
              htmlFor="message"
              style={{
                display: "block",
                fontSize: "1.2rem",
                marginBottom: "5px",
                color: "#333",
              }}
            >
              Message:
            </label>
            <textarea
              id="message"
              name="message"
              rows="6"
              value={formData.message}
              onChange={handleChange}
              required
              style={{
                width: "95%",
                padding: "10px",
                fontSize: "1rem",
                borderRadius: "5px",
                border: "1px solid #ccc",
                color: "#333",
              }}
            />
          </div>
          <div style={{ textAlign: "center" }}>
            <button
              type="submit"
              style={{
                padding: "10px 20px",
                fontSize: "1.2rem",
                backgroundColor: "#007bff",
                color: "#fff",
                border: "none",
                borderRadius: "5px",
                cursor: "pointer",
              }}
            >
              Send Message
            </button>
          </div>
        </form>
      </section>
    </div>
  );
};

export default ContactUsPage;
